import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, tap, concatMap, finalize, catchError } from 'rxjs';
import { BaseService } from '@easy-lib/modules/shared/services/Base/base.service';

@Injectable()
export class LoadingService extends BaseService {
	private loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	private retryLoadingSubject = new BehaviorSubject<boolean>(false);
	retryLoading$ = this.retryLoadingSubject.asObservable();
	showLoaderUntilCompelete<T>(obs$: Observable<T>): Observable<T> {
		return of(null).pipe(
			tap(() => {
				this.loadingOn();
			}),
			concatMap(() => obs$),
			finalize(() => {
				this.loadingOff();
			}),
			catchError(error => {
				this.retryLoadingOn();
				return this.httpService.handleError(error);
			})
		);
	}
	loadingOn() {
		this.retryLoadingOff();
		this.loadingSubject.next(true);
	}
	loadingOff() {
		this.loadingSubject.next(false);
	}
	retryLoadingOn() {
		this.retryLoadingSubject.next(true);
	}
	retryLoadingOff() {
		this.retryLoadingSubject.next(false);
	}
}
export type loadingModel = { loading: boolean; retryLoading: boolean };
